<div class="px-3 fw-bold" [ngStyle]="{ background: publishLevelBackground() }">{{ level() }}</div>
